import React, { useEffect, useState } from "react";
import { WEEK, openStatus, hoursLabel, todayDay } from "@/lib/hours";

export function useOpenStatus() {
  const [status, setStatus] = useState(() => openStatus());
  useEffect(() => {
    const t = setInterval(() => setStatus(openStatus()), 60000);
    return () => clearInterval(t);
  }, []);
  return status;
}

export function StatusDot({ open, className = "" }) {
  return (
    <span className={`relative inline-flex w-2.5 h-2.5 ${className}`}>
      {open && <span className="absolute inset-0 rounded-full bg-green-500 opacity-60 animate-ping" />}
      <span className={`relative w-2.5 h-2.5 rounded-full ${open ? "bg-green-500" : "bg-red-500"}`} />
    </span>
  );
}

export function WeekHours({ testid = "week-hours" }) {
  const today = todayDay();
  return (
    <ul className="space-y-1 text-sm" data-testid={testid}>
      {WEEK.map((w) => (
        <li key={w.day} className={`flex justify-between gap-6 ${w.day === today ? "font-bold text-[#072135]" : "text-[#4B5563]"}`}>
          <span>{w.label}</span><span className="font-mono-tech">{hoursLabel(w.day)}</span>
        </li>
      ))}
    </ul>
  );
}

/* Header badge: status text + weekly hours popover on hover */
export function OpenStatusBadge() {
  const status = useOpenStatus();
  return (
    <div className="relative group hidden xl:block" data-testid="header-open-status">
      <div className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider whitespace-nowrap cursor-default" style={{ color: status.open ? "#15803D" : "#B91C1C" }}>
        <StatusDot open={status.open} /> {status.open ? "Ouvert" : "Fermé"}
      </div>
      <div className="absolute right-0 top-full pt-3 opacity-0 invisible translate-y-1 group-hover:opacity-100 group-hover:visible group-hover:translate-y-0 transition-[opacity,transform] duration-150 z-50">
        <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-4 w-64">
          <div className="text-xs font-bold text-[#072135] mb-3" data-testid="header-open-status-label">{status.label}</div>
          <WeekHours testid="header-week-hours" />
        </div>
      </div>
    </div>
  );
}
